import React from 'react'
import get from 'lodash/get'

import Link from '@components/link'
import { withGlobalContext } from '@util/global_context'
import styles from '@components/programmatic_blocks/experts_list.module.scss'
import ImageAsset from '@components/image_asset'

const linkTitle = expert => (
  <Link
    href={expert.fields.websiteLink}
    className={styles.expert__name}
    target="_blank"
    rel="noopener"
  >
    {expert.fields.name}
  </Link>
)

const normalTitle = expert => <div className={styles.expert__name}>{expert.fields.name}</div>

const ExpertsList = ({ globalContext, data, locale }) => {
  let experts = globalContext.experts

  const expertBlocks = experts.map((expert, i) => {
    let expertName = expert.fields.websiteLink ? linkTitle(expert) : normalTitle(expert)
    return (
      <div key={i} className={styles.expert}>
        <div className={styles.expert__profile}>
          <ImageAsset
            asset={get(expert, 'fields.image')}
            width="165"
            height="165"
            alt="Expert headshot"
          />
        </div>
        {expertName}
        <div className={styles.expert__description}>{expert.fields.description}</div>
      </div>
    )
  })
  return (
    <div className={styles.expertsBlock}>
      <div className={styles.expertsList}>{expertBlocks}</div>
    </div>
  )
}

export default withGlobalContext(ExpertsList)
